// extracted by mini-css-extract-plugin
export default {"wrapper":"A_Indicator_wrapper__rQbjy","text":"A_Indicator_text__qm-q3"};